import { render } from "./realData.vue?vue&type=template&id=0af63a1b"
import script from "./realData.vue?vue&type=script&lang=js"
export * from "./realData.vue?vue&type=script&lang=js"

import "./realData.vue?vue&type=style&index=0&id=0af63a1b&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__